export default [
  {
    for: 'product',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
      unlockEntity: true,
      blockEntity: true,
    },
  },
  {
    for: 'product-family',
    actions: {
      update: true,
      read: true,
      unlockEntity: true,
      blockEntity: true,
    },
  },
  {
    for: 'web-series',
    actions: {
      update: true,
      read: true,
    },
  },
  {
    for: 'tool-itunes-import',
    actions: {
      update: true,
      read: true,
    },
  },
  {
    for: 'tool-mmc-importer',
    actions: {
      update: true,
      read: true,
    },
  },
  {
    for: 'tool-itunes-ids-uploader',
    actions: {
      update: true,
      read: true,
    },
  },
];
